module.exports = __webpack_public_path__ + "img/Pisces.f2b80ce6.png";